const PATH_SEPARATOR = ' / '

export const buildAncestorPathText = (
  path: string[],
  nameByUuid: ReadonlyMap<string, string>
): string =>
  path
    .slice(0, -1)
    .map(uuid => nameByUuid.get(uuid))
    .filter((name): name is string => name !== undefined)
    .join(PATH_SEPARATOR)
